const styles = {
  section: {
    borderBottom: 'none'
  },
  left: {
    textAlign: 'left'
  },
  center: {
    textAlign: 'center'
  },
  empty: {
    fontSize: '16px',
    textAlign: 'center',
    display: 'block',
    width: '100%',
    color: '#8b8b8b'
  },
  intro: {
    padding: '0 10px',
    fontSize: '16px',
    lineHeight: '22px'
  }
}

export default styles
